import React, { useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { routes } from '../../constants';

import { langType, withLang } from '../../i18n';
import TabsContainer from '../TabsContainer';
import TabPane from '../TabPane';
import useTitle from '../../hooks/useTitle';

const AdminTools = ({ translate: t }) => {
  const location = useLocation();
  const navigate = useNavigate();
  useTitle(t('adminTools.title'));
  useEffect(() => {
    if (location.pathname === routes.adminTools.index) {
      navigate(routes.adminTools.permissions.index, { replace: true });
    }
  }, [location]);

  const routesWithTabs = [
    routes.adminTools.permissions.index,
    routes.adminTools.activityLog
  ];
  const showTabs = routesWithTabs.some((route) => location.pathname === route);
  return (
    <div>
      {showTabs ? (
        <div className="page-container">
          <h1>{t('adminTools.title')} </h1>
          <TabsContainer key={window.location.pathname}>
            <TabPane label={t('adminTools.permissions')} icon="icon--wrench" route="/permissions">
              <Outlet />
            </TabPane>
            <TabPane label={t('adminTools.activityLog')} icon="icon--list" route="/activity-log">
              <Outlet />
            </TabPane>
          </TabsContainer>
        </div>
      ) : <Outlet />}
    </div>
  );
};

AdminTools.propTypes = {
  ...langType
};

export default withLang(AdminTools);
